<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/17XCnyM/tc-custom/9781035825707.jpg?1718106146991" alt="This image is the cover for the book Katy and Snowflake"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Katy and Snowflake
      </h1>
      <p class="bookDescription body article font2">
        <p>Did you know that wombats are marsupials (that means their babies live in a pouch) and live in burrows underground? <br/>Sadly, sometimes they lose their mummy and need help from us to survive and go back to the wild. <br/>Around the world, there are many types of wildlife that need help. There are many people who help them – it may even be someone you know!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fiona Thollar
      </h2>
      
      <p class="authorDescription body article">Fiona Thollar is a mother and grandmother, a vocational education teacher, a registered nurse, and a wildlife carer to orphaned and injured animals.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1b3cffc3